"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyRow = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var BodyCell_1 = require("./BodyCell");
var Column_1 = require("./Column");
var DataGridColors_1 = require("./DataGridColors");
var RowHeaderCell_1 = require("./RowHeaderCell");
var BodyRow = /** @class */ (function (_super) {
    tslib_1.__extends(BodyRow, _super);
    function BodyRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBackgroundColor = function () {
            if (_this.props.isSelected) {
                return DataGridColors_1.DataGridColors.Selected;
            }
            else if ( /* !this.props.showHorizontalGridLines && */_this.props.showRowBanding && _this.props.rowIdx % 2 === 0) {
                return DataGridColors_1.DataGridColors.AltRow;
            }
            return undefined;
        };
        _this.handleRowHeaderCellClick = function (e) {
            if (!!_this.props.row && !!_this.props.onRowHeaderCellClick) {
                _this.props.onRowHeaderCellClick(_this.props.rowIdx, e);
            }
        };
        return _this;
    }
    BodyRow.prototype.isCellSelected = function (cell) {
        return !!this.props.selectionModel && this.props.selectionModel.isSelected(cell);
    };
    BodyRow.prototype.renderCells = function () {
        var columnWidths = this.props.columnWidths || {};
        var cells = [];
        if (!!this.props.onRowHeaderCellClick && this.props.colStartIdx === 0) {
            cells.push(React.createElement(RowHeaderCell_1.RowHeaderCell, tslib_1.__assign({}, {
                key: "hcell",
                height: this.props.rowOuterHeight,
                isSelected: this.props.isSelected,
                onRowHeaderCellClick: this.handleRowHeaderCellClick,
                rowType: RowHeaderCell_1.RowHeaderCell.RowType.Body,
                testId: 'hcell'
            })));
        }
        for (var colIdx = this.props.colStartIdx; colIdx <= this.props.colEndIdx; colIdx++) {
            var col = this.props.cols[colIdx];
            var shouldReportWidth = !col.preferredWidth && this.props.measuredColumnWidths[col.name] === undefined;
            cells.push(React.createElement(BodyCell_1.BodyCell, tslib_1.__assign({}, {
                key: col.name,
                col: col,
                row: this.props.row,
                rowIdx: this.props.rowIdx,
                colIdx: colIdx,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value: this.props.row.data[col.dataKey],
                width: shouldReportWidth ? undefined : columnWidths[col.name],
                height: this.props.rowOuterHeight,
                reportWidthFn: shouldReportWidth ? this.props.reportWidthFn : undefined,
                isSelected: this.isCellSelected({ rowIdx: this.props.rowIdx, colIdx: colIdx, rowKey: this.props.row.key, colKey: col.dataKey }),
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                showVerticalGridLines: this.props.showVerticalGridLines
            })));
        }
        return cells;
    };
    BodyRow.prototype.render = function () {
        var _this = this;
        var borderBottom = this.props.isSelected ? "1px solid " + DataGridColors_1.DataGridColors.SelectedGridLine : (this.props.showHorizontalGridLines ? "1px solid " + DataGridColors_1.DataGridColors.HorizontalGridLine : undefined);
        var style = {
            backgroundColor: this.getBackgroundColor(),
            borderBottom: borderBottom,
            boxSizing: 'border-box',
            height: this.props.rowOuterHeight,
            paddingLeft: this.props.leftMargin || 0,
            whiteSpace: 'nowrap'
        };
        return React.createElement(Column_1.ColumnHeadersContext.Consumer, null, function (showColumnHeaders) { return React.createElement("div", tslib_1.__assign({}, {
            'aria-rowindex': _this.props.rowIdx + (showColumnHeaders ? 2 : 1),
            'aria-selected': _this.props.isSelected,
            /**
             * 733183: "Scrolling past ~2000 rows causes a fatal rendering error"
             * The row prop can be undefined at runtime. This specifically occurs if the rowStore does not return the rows associated with the requested start
             * and end row indexes. As such, we can hit a situation where our DataGrid is expecting defined rows for row indexes that were not actually returned
             * from the rowStore. When this happens we render a styled empty BodyRow.
             */
            children: _this.props.row && _this.renderCells(),
            className: 'tb-react-dg-brow',
            role: 'row',
            style: style,
        })); });
    };
    BodyRow.defaultProps = { showRowBanding: true };
    BodyRow.displayName = 'DataGridBodyRow';
    return BodyRow;
}(React.PureComponent));
exports.BodyRow = BodyRow;
//# sourceMappingURL=BodyRow.js.map